<template>
    <div class="preview">
        <div class="title">{{title}}</div>
        <div class="container" ref="container" ></div>
        <tool 
            v-if="readyScene" 
            :measureData="measureData"
            :flyData="flyData"
        >
        </tool>
        <!-- <button class="btn btn_1" @click.stop="toEditor">编辑场景</button> -->
    </div>
</template>

<script>
import InitMixin from '@/mixins/earthInit'
import Tool from './Tool.vue'
import Cookie from "js-cookie"

export default {

    mixins: [ InitMixin ],

    components: {
        Tool
    },

    mounted(){
        this.init( true, this.$route.query.fromBack == '1' )
    },

    methods: {
        toEditor(){
            if( !this.$store.state.login.loginId || !Cookie.get('loginId') ){
                this.$root.loginVisible = true
            }else{
                this.$router.push({
                    path: `/editor?id=${this.$route.query.id}`
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.preview{
    width: 100vw; height: 100vh; position: relative; padding: 0; margin: 0; overflow: hidden;
    .container{ width: 100%; height: 100%; }
    .title{ position: fixed; top: 0; left: 0; width: 100vw; height: 60px; line-height: 60px; text-align: center; color: #FFF; background-color: rgba(0,0,0,0.5); z-index: 2; font-size: 16px; }
}
.btn{
    width: 88px; height: 34px; border-radius: 17px; text-align: center; line-height: 34px; position: fixed; top: 30px; cursor: pointer;
}
.btn_1{
    background-color: #1458EA; color: #FFF; left: 30px;
}
</style>
